export interface CalendarAssignmentEmployee {
  id: number;
  name: string;
  personnelNumber: string;
}

// employees здесь были CalendarAssignmentEmployee
export interface CalendarAssignment {
  employees: CalendarAssignmentEmployee[];
  calendar: Record<
    string,
    {
      calendarId: number;
      calendarName: string;
      type: number;
    }
  >;
}

export enum TimelineScale {
  MONTH = 'month',
  WEEK = 'week',
  DAY = 'day'
}

export interface DaySchedule {
  id?: number;
  start: string;
  end: string;
  departmentId: number;
  workdayStart: string;
  workdayDuration: string;
  break: string;
  isTemplate: boolean;
  guid: string;
}

// Словарь расписания по дате, где ключ — строка в формате YYYY-MM-DD
export type DepartmentSchedules = Record<string, DaySchedule[]>;
// Словарь расписаний по сотрудникам
export type EmployeeDailyShifts = DaySchedule[];

// Represents a dictionary of dates to arrays of shifts for an employee
export type EmployeeSchedules = Record<string, EmployeeDailyShifts>;

// Represents a dictionary of employee IDs to their schedules
export type EmployeesSchedules = Record<string, EmployeeSchedules>;

export interface TimelineItem {
  id: number | string;
  group: number | string;
  title: React.ReactNode;
  start_time: number;
  end_time: number;
  className?: string;
  titleStyle?: React.CSSProperties;
  itemProps?: {
    style?: React.CSSProperties;
    [key: string]: any;
  };
  guid?: string; // Добавляем новое поле
}
